<template>
  <div :class="['listComment', listClassName]">
    <ul>
      <li v-for="(it, index) in listdata" :key="index">
        <img :src="it.img" />
        <div class="text">
          <h4>{{ it.h4 }}</h4>
          <p>{{ it.p }}</p>
        </div>
        <slot></slot>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "listVue",
  components: {},
  props: {
    listdata: {
      type: Array,
      default: [],
    },
    listClassName: {
      type: String,
      default: "listIndex",
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.listComment {
  margin-top: 50px;
  li {
    h4 {
      color: #333;
      font-size: 28px;
    }
    p {
      font-size: 24px;
      color: #999;
      margin-top:10px;
    }
  }
}
.indexMd1 {
  margin: 50px 30px 0 50px;
  li {
    display: flex;
    margin-bottom: 50px;
    align-items: center;
    img {
      display: block;
      width: 296px;
      height: 179px;
      margin-right: 20px;
    }
  }
}
.indexMd2 {
  padding: 80px 50px 50px 20px;
  background: #f4f7fe;
  li {
    display: flex;
    margin-bottom: 40px;
    align-items: center;
    img {
      display: block;
      width: 119px;
      height: 112px;
      margin-right: 20px;
    }
  }
}
.indexMd3 {
  ul {
    padding: 30px 14px 50px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    li {
      padding: 30px 20px;
      box-sizing: border-box;
      width: 345px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      border: 1px solid #055dd8;
      text-align: center;
      margin-bottom:13px;
      h4 {
        color: #055dd8;
        width: 243px;
       margin:30px auto;
       text-align: center;
      }
      p{
        text-align: justify;
      }
      img {
        display: block;
        width: 189px;
        height: 135px;
      }
    }
  }
}
</style>
